export default "__VITE_ASSET__BmdRcj2M__"